const openBracket = {
  match: '(',
}

export default openBracket
